import { render, staticRenderFns } from "./no-route.vue?vue&type=template&id=aec95e3a&"
import script from "./no-route.vue?vue&type=script&lang=js&"
export * from "./no-route.vue?vue&type=script&lang=js&"
import style0 from "./no-route.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports